import AccountSummaryPage from "components/pages/AccountSummaryPage";

export default function CaptureAccountsAccountSummary(props) {
    return <AccountSummaryPage />
}